import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { AutoFocus } from 'primeng/autofocus';
import { Chip } from 'primeng/chip';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { BaseAddPaymentPageLinkComponent } from '../../base/base-add-payment-page-link.component';

@Component({
  selector: 'add-form-payment-page-link-presentation',
  imports: [
    Select,
    FormsModule,
    NgClass,
    InputText,
    AutoFocus,
    Chip,
  ],
  templateUrl: './add-form-payment-page-link-presentation.component.html'
})
export class AddFormPaymentPageLinkPresentationComponent extends BaseAddPaymentPageLinkComponent implements OnInit {

  languageList: SelectItem[] = [];
  /**
   * model to add new donation-project name
   */
  newDonationProjectName: string;

  ngOnInit() {
    this.languageList = this.settingsProvider.paymentPageLanguages();
  }

  /**
   * Add new donation project name to list
   */
  addNewDonationProject() {
    if (this.paymentPageLinkData.donationProjectList.find(item => item === (this.newDonationProjectName))) {
      this.messageService.add({
        life: 3500,
        severity: 'info',
        summary: this.i18n.i18nLng()['INFORMATION'],
        detail: this.i18n.i18nLng()['AMOUNTEXISTS']
      });
    } else {
      this.paymentPageLinkData.donationProjectList.push(
        this.newDonationProjectName
      );
      this.newDonationProjectName = null;
    }
    this.dataChanged.emit();
  }

  /**
   * remove donation project name from list
   * @param projectName
   */
  removeDonationProject(projectName: string) {
    this.paymentPageLinkData.donationProjectList = this.paymentPageLinkData.donationProjectList.filter(item => item !== projectName);
    this.dataChanged.emit();
  }

}
